import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseApiService } from './base-api.service';
import { apiResponseFactory } from 'src/app/models/response/apiResponseFactory';
import { kontniPlanDto } from '../models/financije/kontniPlanDto';
import { PagedResponse } from '../models/paged-response.model';

@Injectable({
  providedIn: 'root'
})
export class KontniPlanService {
  constructor(private api: BaseApiService) { }

  getAll() {
    return this.api.get('financije/kontni-plan/all',).pipe(
      map((response: HttpResponse<apiResponseFactory>) => {
        if (response.status == 200 && response?.body?.result) {
          return response.body.result.map(
            (kontniPlan) => new kontniPlanDto(kontniPlan)
          );
        }
        return undefined;
      }),
      catchError(this.handleError<kontniPlanDto[]>(`financije/kontni-plan/all`))
    );

  }

  getPaged(params: any): Observable<PagedResponse<kontniPlanDto>> {
    return this.api.post('financije/kontni-plan', params).pipe(
      map((response) => {
        const pagedModel = new PagedResponse<kontniPlanDto>(
          response.body.result
        );
        pagedModel.items = pagedModel.items?.map((i) => new kontniPlanDto(i));
        return pagedModel;
      })
    );
  }

  getbyKonto(params: any): Observable<any> {
    return this.api
      .post('financije/kontni-plan/by-konto', params)
      .pipe(catchError(this.handleError<[]>(`financije/kontni-plan/by-konto`)));
  }

  update(params: any = {}): Observable<any> {
    return this.api
      .post('financije/kontni-plan/update', params)
      .pipe(catchError(this.handleError<[]>('financije/kontni-plan/update')));
  }

  create(params: any = {}): Observable<any> {
    return this.api
      .post('financije/kontni-plan/create', params)
      .pipe(catchError(this.handleError<[]>('financije/kontni-plan/create')));
  }


  delete(params: any): Observable<any> {
    return this.api
      .post('financije/kontni-plan/delete', params)
      .pipe(catchError(this.handleError<[]>('financije/kontni-plan/delete')));
  }

  deleteAll(): Observable<any> {
    return this.api
      .post('financije/kontni-plan/delete-all', {})
      .pipe(catchError(this.handleError<[]>('financije/kontni-plan/delete-all')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
